import { createSlice } from "@reduxjs/toolkit";

const nameSlice = createSlice({
    name:'Global',
    initialState:{
        IndexDeliveryList:[
             {
                caption:'上架',
                href:'/solution/delivery',
                img:require('@/assets/home/Delivery1.webp'),
             },
             {
                caption:'改配',
                href:'/solution/delivery',
                img:require('@/assets/home/Delivery2.webp'),
             }, 
             {
                caption:'搬迁',
                href:'/solution/delivery',
                img:require('@/assets/home/Delivery3.webp'),
             }, 
        ],
        IndexOperationsList:[
             {
                caption:'备件',
                href:'/solution/devOps',
                img:require('@/assets/home/Operations1.webp'),
             },
             {
                caption:'维保',
                href:'/solution/devOps',
                img:require('@/assets/home/Operations2.webp'),
             }, 
             {
                caption:'延保',
                href:'/solution/devOps',
                img:require('@/assets/home/Operations3.webp')
             }, 
        ],
        OperationsList:[//运维
            {
                center:'GPU Server Operation and Maintenance Case',
                text:'GPU服务器运维案例',
                bgCover: require("@/assets/serve/TOPbanner.webp"), 
            }
        ],
        OperationsBackgroundList:[//运维服务
            {
                title:'项目背景',
                matter:'客户是全球领先的互联网科技企业，对GPU服务器的需求量巨大且对定制化要求极高。同时，对服务水平的期望同样严苛，要求提供7*24*4小时的优质售后服务，以保障其业务的连续性和稳定性。'
            }
        ],
        OperationSpainSpotList:[//运维痛点
            {
                code:'01',
                spot:'地点偏远，常规网点不能覆盖',
            },
            {
                code:'02',
                spot:'时效要求高，运输条件差',
            },
            {
                code:'03',
                spot:'缺乏GPU运维的标准流程',
            },
            {
                code:'04',
                spot:'GPU模组整体更换模式，客户备件压力大',
            },
            {
                code:'05',
                spot:'备件安全问题，运维过程缺乏全程监督 ',
            },
            {
                code:'06',
                spot:'备件退运流程复杂',
            }

        ],
        OperationSolutionList:[//维云芯解决方案
            {
                caption:'',
                desc:'15天内设立就近网点，人员配备齐全，可以正常接收备件',
            },
            {
                caption:'',
                desc:'配置专车上门服务，24小时即时处理工单',
            },
            {
                caption:'',
                desc:'强大供应链能力帮客户备足料件，极大减少客户备件压力',
            },
            {
                caption:'',
                desc:'制定完整的GPU运维流程和技术文档，2天内掌握所有设备',
            }, 
            {
                caption:'',
                desc:'成熟的物流体系帮助客户打通退运流程，极大减少扭转时效',
            },  
            {
                caption:'',
                desc:'运维人员全程配备记录仪，让客户随时可以查看运维实况',
            }                          
        ],
        ReconfigurationList:[//重新配置
            {
                center:'GPU Server Upgrade Case Study',
                text:'GPU服务器改配案例',
                bgCover: require("@/assets/serve/TOPbanner.webp"), 
            }
        ],
        ReconfigurationBackgroundList:[//重新配置服务
            {
                title:'项目背景',
                matter:'该客户专注于提供领先的互联网服务，包括社交媒体、在线教育、游戏、电商等。对服务器性能有严格的标准，采用高端GPU为核心计算组件，以提供卓越的计算能力，满足在深度学习、大数据处理和人工智能等领域的需求。'
            }
        ],
        ReconfigurationSpainSpotList:[//重新配置痛点
            {
                code:'01',
                spot:'GPU服务器的测试环境要求极为严格',
            },
            {
                code:'02',
                spot:'组装技术具有高度复杂性',
            },
            {
                code:'03',
                spot:'面临多品牌服务器的整合挑战',
            },
        ],
        ReconfigurationSolutionList:[//重新配置解决方案
            {
                caption:'高效快速的响应能力',
                desc:'项目洽谈、场地适配、整体配置、落地实施，全方位满足响应时效',
            },
            {
                caption:'完善的项目方案整合及输出能力',
                desc:'多家ODM厂商存在生产流程、测试程序、工具等标准差异，协调整合、统一标准输出',
            },
            {
                caption:'拥有GPU实战经验',
                desc:'工程师均具备GPU 服务器（A&H系列）运维实操经验，资深FAE团队皆有超过一年以上的H800运维、故障分析经验',
            },                         
        ],
        RemovalList:[//搬迁
            {
                center:'GPU Server Migration Case Study',
                text:'GPU服务器搬迁案例',
                bgCover: require("@/assets/serve/TOPbanner.webp"), 
            }
        ],
        RemovalBackgroundList:[//搬迁服务
            {
                title:'项目背景',
                matter:'客户是头部互联网企业，确保其IT基础设施能够支持大规模的数据处理和复杂的计算任务，决定对GPU服务器进行跨城市搬迁，以保证业务运营能够得到更加稳定和高效的支持。'
            }
        ],
        RemovalSpainSpotList:[//搬迁痛点
            {
                code:'01',
                spot:'行业内无大规模GPU服务器搬迁经验',
            },
            {
                code:'02',
                spot:'高端GPU服务器搬迁安全保障挑战',
            },
        ],
        RemovalSolutionList:[//搬迁解决方案
            {
                caption:'',
                desc:'对潜在风险进行了耐心而前瞻性的预测与评估，在安全、运输、现场作业、时效四个关键方面进行了全面部署和风险应对计划。',
            },
            {
                caption:'',
                desc:'制定标准化的搬迁流程和严格的高精度作业管控措施，配套专业技术团队，极大提升搬迁过程中各个环节的衔接度，有效降低了风险发生的可能性，确保搬迁工作的高效与高质量完成。',
            },                         
        ],
        ProductList:[//产品
            {
                center:'Product Services',
                text:'产品服务',
                bgCover: require("@/assets/product/TOPbanner.webp"),
            }           
        ],
        ProductTypeList:[//产品类型
            {
              cover: require("@/assets/product/Type1.webp"),
            },
            {
              cover: require("@/assets/product/Type2.webp"),
            },
            {
              cover: require("@/assets/product/Type3.webp"),
            },
            {
              cover: require("@/assets/product/Type4.webp"),
            },
        ],
        AboutUsList:[//关于我们顶部
            {
                center:'About Us',
                text:'守护算力心跳，智启AI未来',
                bgCover: require("@/assets/About/TOPbanner.webp"),
            }
        ],
        AboutIntroList:[//关于我们介绍
            {
                Img:require("@/assets/About/Intro.webp"),
                topVerse:'公司简介',
                bottomVerse:'广东维云芯信息科技有限公司成立于2023 年，是一家专注于提供高新、高价值的AI服务器运维服务和备件服务的科技前沿企业，并拥有专业的运维团队和全球服务网络，提供无缝、高效的跨地域支持，已成为全球众多CSP/ISV龙头企业数据中心基础设施售后服务的首选供应商。',
            }

        ],
        AboutNotionList:[//关于我们Notion
            {
                caption:'愿景和使命',
                explain:[
                    {
                        content:'成为全球AI算力可信赖的运维伙伴，用技术创新重塑超算与数据中心的可持续未来。'
                    },
                    {
                        content:'为客户提供专业、敏捷、智能的一站式运维技术支持，守护您的核心算力资产。'
                    },
                    {
                        content:'坚持创新驱动与专业深耕，聚焦AI基础架构领域，为客户打造安全、智能、可持续的算力生态解决方案。'
                    },
                ]
            },
        ],
        SolutionDeliveryList:[//解决方案顶部
            {
                center:'Delivery Solutions',
                text:'交付解决方案',
                bgCover: require("@/assets/solution/TOPbanner.webp"),
            }
        ],
        SolutionDataDeliveryList:[
            {
                title:'GPU服务器的交付',
                content:'维云芯提供全方位的服务器交付服务，涵盖上架、改配与搬迁三大核心环节。在GPU服务器交付阶段，提供专业的工勘报告、定制化SOP及系统化岗前培训，确保部署高效精准。在GPU服务器改配环节，依托客制化改配中心与专业技术团队，支持全系列硬件调整、系统配置和网络优化，实现灵活升级。在服务器搬迁方面，提供端到端解决方案，具备前瞻性风险评估能力，通过标准化流程与高精度作业控制，保障搬迁安全高效。',
                catalogue:[
                    {
                        title:'上架',
                        content:['到货验收','上架安装',' 配置组网'],
                    },
                    {
                        title:'改配',
                        content:['硬件调整','系统搬迁','网络优化'],
                    },
                    {
                        title:'搬迁',
                        content:['灵活搬运','精准定位','高效搬卸'],
                    },
                ]
            },            
        ],
        SolutionDevOpsList:[//解决方案顶部
            {
                center:'Operation and maintenance solutions',
                text:'运维解决方案',
                bgCover: require("@/assets/solution/TOPbanner.webp"),
            }
        ],
        SolutionDataDevOpsList:[
            {
                title:'GPU服务器的运维',
                content:'维云芯提供全面、专业的服务器运维服务，涵盖维保、延保与备件三大核心业务。在维保服务方面，创新“三线运维体系”，提供专业技术支持，响应时间可满足7x24 小时，保障系统稳定运行。延保服务针对通用服务器、模组化GPU服务器及边缘服务器等，在原厂保修期结束后，通过维保合约延续硬件支持，延长设备生命周期。备件服务实现30分钟内快速响应，配备客制化备件仓和驻点工程师专车上门，确保故障快速修复，最大限度减少停机时间，全面提升运维效率与可靠性。',
                catalogue:[
                    {
                        title:'维保',
                        content:['创新“三线运维体系”','中高端服务器运维经验','专案定制技术服务','响应时间SLA： （7*24*4） （ 7*24ND）（ 7*8 NCD ） （ 5*8 NBD）等'],
                    },
                    {
                        title:'延保',
                        content:['针对通用服务器、模组化GPU服务器及边缘服务器等，在原厂保修期结束后，通过维保合约延续硬件支持，延长设备生命周期。'],
                    },  
                    {
                        title:'备件',
                        content:['客制化备件仓设点30分钟内到达','驻点工程师专车备件上门','原厂级直供全机型备件供应'],
                    },
                ]
            },           
        ],
        SolutionRepairList:[//解决方案顶部
            {
                center:'Repair solutions',
                text:'维修解决方案',
                bgCover: require("@/assets/solution/TOPbanner.webp"),
            }
        ],
        SolutionDataRepairList:[
            {
                title:'GPU维修',
                content:'维云芯提供专业高效的GPU维修服务，覆盖A/H/B系列GPU卡及服务器主板。维修流程遵循“9大流程、48道工序”的严谨体系，涵盖需求确认、收货、IQC检测、初检、物料采购、维修、复测、QA质检至发货，确保全流程可控。依托BGA返修台、X-Ray检测仪、短路测试仪等原厂级设备，保障修复质量，平均修复率超95%，并提供最长3年延保。维修范围包括主流GPU显卡及服务器核心板卡，支持故障诊断与修复。全过程通过MES系统追踪与全链路录像记录，实现资产安全率100%，确保客户数据与设备安全无忧。',
                catalogue:[]
            },            
        ],
    },
    reducers:{
        changeState(state,{payload}){
            console.log('jinlai le',payload)
            state.globalData = payload
        }
    }
})
export const getters = (state)=>{
    console.log('++++++++++++',state)
    return state.Global
}
export const {changeState} = nameSlice.actions
export default nameSlice.reducer
